export default "__VITE_ASSET__TmbHgQa4qD5g3LfZTFHWKA__"